
let preventOutsideClick = false

export default {
  name: 'AppModal',
  props: {
    size: {
      type: String,
      default: 'sm',
      validator (value) {
        return ['sm', 'md', '2md', 'lg', 'xl'].includes(value)
      }
    },
    height: {
      type: String,
      default: 'auto',
      validator (value) {
        return ['auto', 'xl'].includes(value)
      }
    },
    value: {
      type: Boolean,
      // ignore no-boolean-default rule here, because if the v-model does not exist
      // the modal should be displayed by default
      // eslint-disable-next-line vue/no-boolean-default
      default: true
    },
    mainStyle: {
      type: Object,
      default () {
        return {}
      }
    },
    isForm: Boolean,
    hideHeader: Boolean,
    hideCloseIcon: Boolean,
    disableCloseOnOverlay: Boolean
  },
  computed: {
    defaultScopedSlotValues () {
      return {
        close: this.close
      }
    },
    hasFooter () {
      for (const slot of [
        'before-buttons',
        'buttons-left',
        'buttons-right',
        'after-buttons'
      ]) {
        if (this.$slots[slot] || this.$scopedSlots[slot]) {
          return true
        }
      }

      return false
    },
    style () {
      const styles = {
        width: '100%',
        maxWidth: '1300px'
      }

      if (this.size === 'sm') {
        styles.maxWidth = '600px'
      } else if (this.size === 'md') {
        styles.maxWidth = '700px'
      } else if (this.size === '2md') {
        styles.maxWidth = '1000px'
      } else if (this.size === 'xl') {
        styles.maxWidth = '1700px'
      }

      if (this.height === 'xl') {
        styles.height = '100vh'
      }

      return styles
    }
  },
  watch: {
    value (newValue, oldValue) {
      if (!newValue || oldValue === newValue) {
        return
      }

      this.focus()
    }
  },
  mounted () {
    this.focus()
  },
  methods: {
    focus () {
      this.$nextTick(() => {
        const autofocusElement = this.$refs.container?.querySelector('[autofocus],input:first-of-type')
        autofocusElement?.focus()
      })
    },
    close () {
      preventOutsideClick = true

      this.$emit('input', false)
      this.$emit('close')

      window.setTimeout(() => {
        preventOutsideClick = false
      }, 10)
    },
    clickedOutside () {
      if (preventOutsideClick || this.disableCloseOnOverlay) {
        return
      }

      if (this.$refs.container === document.querySelector('#modals-portal > div:last-of-type')) {
        this.close()
      }
    }
  }
}
